var React = require('react');

function RecordVinyl (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 128a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 152a24 24 0 1 1 24-24 24 24 0 0 1-24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z","className":"fa-primary","key":2})]);
}

RecordVinyl.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = RecordVinyl;

RecordVinyl.default = RecordVinyl;
